import { authFetch } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export interface SyncGhlEmrResult {
    inserted: number;
    updated: number;
    skipped: number;
}

export interface TriggerEmrMastersResult {
    execution: string;
}

export interface JobStatusResult {
    status: string;
}

export const syncApi = {
    async syncGhlEmrFromEngine(): Promise<SyncGhlEmrResult> {
        const response = await authFetch(`${API_BASE_URL}/sync/ghl-emr-from-engine`, {
            method: 'POST',
        });
        if (!response.ok) {
            const detail = await response.json().catch(() => ({}));
            throw new Error(detail?.detail || 'Sync failed');
        }
        return response.json();
    },

    async triggerEmrMasters(): Promise<TriggerEmrMastersResult> {
        const response = await authFetch(`${API_BASE_URL}/sync/trigger-emr-masters`, {
            method: 'POST',
        });
        if (!response.ok) {
            const detail = await response.json().catch(() => ({}));
            throw new Error(detail?.detail || 'Failed to trigger sync');
        }
        return response.json();
    },

    async getJobStatus(execution: string): Promise<JobStatusResult> {
        const response = await authFetch(
            `${API_BASE_URL}/sync/job-status?execution=${encodeURIComponent(execution)}`
        );
        if (!response.ok) {
            const detail = await response.json().catch(() => ({}));
            throw new Error(detail?.detail || 'Failed to fetch job status');
        }
        return response.json();
    },
};
